import { useMemo } from "react";
import { usePaywallCheckoutContext } from "@/react/contexts/Paywalls/paywallCheckoutContext";
import type { StripeElementsAddressElementOptions } from "../../../StripeElements/types";
import { getCurrentUserName } from "../../helpers/users";

export const useAddressElementDefaultValues =
  (): StripeElementsAddressElementOptions["defaultValues"] => {
    const { currentUser, memberBillingInfo } = usePaywallCheckoutContext();

    // If there is a community member logged in, we prefill the Address Element with their name.
    //
    // Otherwise, we rely on the Address Element to provide our form with the values it requires
    // to sign up the new community member.
    //
    // Our form does not render the name field if the Address Element is rendered.
    const name = getCurrentUserName(currentUser);

    // We prefill the Address Element with the community member's address if they have already
    // provided one.
    const address = memberBillingInfo;

    return useMemo(
      () => ({
        name,
        address: {
          line1: address?.address_line1,
          line2: address?.address_line2,
          city: address?.address_city,
          state: address?.address_state,
          postal_code: address?.address_postal_code,
          country: address?.address_country,
        },
      }),
      [name, address],
    );
  };
